import { lazy } from "react";
import SuspenseWrapper from "components/SuspenseWrapper";

const AdminUsers = lazy(() => import("modules/admin-users/AdminUsers"));

export default function AdminUsersPage() {
  return (
    <SuspenseWrapper>
      <AdminUsers />
    </SuspenseWrapper>
  );
}
